import axios from "axios";
import {
    url_active_branches,
    url_branch,
    url_branch_depend,
    url_branch_status,
    url_branch_token,
    url_branches
} from "../url";


export default function DB_Branch(token) {

    const formData = new FormData;
    formData.append('token', token)

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getBranches = () => {
        return axios.post(url_branches, formData)
    }

    const getActiveBranches = () => {
        return axios.post(url_active_branches, null, {
            headers: {
                Authorization: token
            }
        })
    }

    const getBranch = (id) => {
        return axios.post(url_branch + id, formData)
    }

    const createBranch = (data) => {
        return axios.post(url_branch, appendToken(data))
    }

    const updateBranch = (data) => {
        return axios.put(url_branch, appendToken(data))
    }

    const statusBranch = (data) => {
        return axios.post(url_branch_status, appendToken(data))
    }

    const getAPItoken = (formData) => {
        return axios.post(url_branch_token, appendToken(formData))
    }

    const dependBranch = (id) => {
        return axios.get(url_branch_depend + id)
    }

    return {
        getBranches,
        getActiveBranches,
        getBranch,
        createBranch,
        updateBranch,
        statusBranch,
        getAPItoken,
        dependBranch
    }
}
